import { Link } from "react-router";
import { ROUTES } from "../links";
import { usePageTitle } from "./usePageTitle";

/** The site's 404, inside the site frame (nav and footer) so there's always a way back. */
export function SiteNotFoundPage() {
  usePageTitle("Page not found");
  return (
    <div className="spage on" data-s="notfound" data-testid="not-found">
      <header className="hero">
        <div className="wrap">
          <p className="mono">404</p>
          <h1 style={{ marginTop: 14 }}>
            We couldn&rsquo;t find <em>that</em> page.
          </h1>
          <p className="lede">The link may be old, or the page may have moved.</p>
          <div className="cta" style={{ marginTop: 28, justifyContent: "center" }}>
            <Link className="sbtn p big" to={ROUTES.home}>
              Go to the homepage
            </Link>
            <Link className="sbtn big" to="/app">
              Open your plan
            </Link>
          </div>
        </div>
      </header>
    </div>
  );
}
